import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { InfoCircleFilled, PictureOutlined } from '@ant-design/icons';
import { PATH } from 'constants/path';
import tagStep1Img from '../imgs/tag-clients-1.png';
import tagStep2Img from '../imgs/tag-clients-2.png';
import tagStep3Img from '../imgs/tag-clients-3.png';
import s from './s.module.less';

// 三步演示截图：Tag 列点 "+" → Add new tags 弹窗输入 Klarity billing → tag 显示在行上
const HOW_STEPS: { img?: string; text: React.ReactNode }[] = [
    {
        img: tagStep1Img,
        text: (
            <>
                In <b>Clients</b>, find the client and click <b>+</b> in the Tag column.
            </>
        ),
    },
    {
        img: tagStep2Img,
        text: (
            <>
                Type <b>Klarity billing</b> and click <b>Add tags</b>.
            </>
        ),
    },
    {
        img: tagStep3Img,
        text: <>The tag now shows on their row. Klarity bills their visits from the next locked note onward.</>,
    },
];

type Props = {
    isGroup: boolean;
};

// 常驻提示而非 blocker：我们看不到 client 是否已打 tag，猜着拦会挡住已经做完的人。
// waiting / 表格态都渲染（仅 Klarity Health 已连时，由父级控制），两个 CTA 都去 Clients 页
const TagClientsBanner = ({ isGroup }: Props) => {
    const navigate = useNavigate();
    const [howOpen, setHowOpen] = useState(false);

    const goClients = () => {
        setHowOpen(false);
        navigate(`${PATH.DASHBOARD}/${PATH.CLIENTS}`);
    };

    return (
        <>
            <div className={s.infoBanner}>
                <InfoCircleFilled className={s.infoBannerIcon} />
                <span className={s.infoBannerText}>
                    To bill Klarity Health visits, go to <b>Clients</b> and add the <b>Klarity billing</b> tag to every
                    client you want billed, new clients included. Billing starts once they are tagged.
                    {isGroup && ' Each provider tags their own clients.'}{' '}
                    <button type="button" className={s.infoBannerGhost} onClick={() => setHowOpen(true)}>
                        See how
                    </button>
                </span>
                <button type="button" className={s.infoBannerAction} onClick={goClients}>
                    Tag clients <span aria-hidden="true">&rarr;</span>
                </button>
            </div>
            <Modal
                open={howOpen}
                onCancel={() => setHowOpen(false)}
                footer={null}
                width={680}
                title="How to tag a client for billing"
            >
                <ol className={s.howList}>
                    {HOW_STEPS.map((step, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={i} className={s.howStep}>
                            <p className={s.howCap}>
                                <span className={s.howNum}>{i + 1}</span>
                                <span>{step.text}</span>
                            </p>
                            <div className={s.howShot}>
                                {step.img ? (
                                    <img src={step.img} alt="" />
                                ) : (
                                    <div className={s.howShotPlaceholder}>
                                        <PictureOutlined />
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
                <div className={s.howFoot}>
                    <Button size="large" className={s.gsCtaBtn} onClick={goClients}>
                        Tag clients
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default TagClientsBanner;
